export default {
  slug: "dental-filling-in-guwahati",
  title: "Dental Fillings in Guwahati",
  subtitle:
    "Safe, long-lasting, and natural-looking solutions to restore damaged teeth",
  heroImage: "/dental-services/dental-fillings/dental-fillings-in-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Dental Fillings in Guwahati",
      content: `
Dental fillings are one of the most common and effective treatments used to restore teeth damaged by decay, cracks, or minor fractures.

If left untreated, cavities can grow deeper, causing pain, infection, and even tooth loss.

At Magnum Dental Clinic, Guwahati, we provide safe, long-lasting, and natural-looking dental fillings to restore the function, strength, and appearance of your teeth.
      `,
    },

    {
      type: "image",
      images: [
        "/dental-services/tooth-colored-restorations.webp",
        "/dental-services/dental-fillings/tooth-filling-in-guwahati.webp",
        "/dental-services/dental-fillings/dental-filling-at-magnum-dental-clinic.webp",
      ],
      caption: "Images are for illustrative purposes only",
    },

    {
      type: "text",
      heading: "What Are Dental Fillings?",
      content: `
A dental filling is a restorative treatment used to repair a tooth affected by decay or minor damage.

After removing the infected or decayed part of the tooth, the space is filled with a suitable dental material to prevent further decay and restore normal chewing function.

Dental fillings help:
✔ Stop cavity progression  
✔ Prevent infection  
✔ Restore tooth shape and strength  
✔ Improve chewing ability  
✔ Maintain natural appearance
      `,
    },

    {
      type: "text",
      heading: "When Do You Need a Dental Filling?",
      content: `
A dentist can clinically examine your teeth and determine whether you need a dental filling.

However, you should visit a dentist if you experience :
• Tooth pain or sensitivity  
• Black or brown spots on teeth  
• Visible holes or pits  
• Food getting stuck frequently  
• Pain while chewing or biting  
• Persistent bad breath caused by decay  

Ignoring these signs can lead to deeper infection, severe pain, or even tooth loss. Early treatment helps save your tooth.
      `,
    },

    {
      type: "text",
      heading: "Benefits of Getting a Dental Filling",
      content: `
• Stops tooth decay from spreading  
• Prevents root canal or extraction  
• Restores normal chewing  
• Improves appearance  
• Strengthens the tooth  
• Long-lasting solution
      `,
    },

    {
      type: "text",
      heading: "Dental Filling at Magnum Dental Clinic, Guwahati",
      content: `
We follow a gentle and safe treatment process:

1. Examination and X-rays (if needed)  
2. Removal of decayed portion  
3. Cleaning and disinfecting the area  
4. Filling the tooth with suitable material  
5. Shaping and polishing for natural appearance  

The procedure is quick, comfortable, and usually completed in a single visit.
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Fillings?",
      content: `
✔ Experienced dentists  
✔ High-quality filling materials  
✔ Natural-looking results  
✔ Comfortable treatment  
✔ Affordable pricing  
✔ Strict hygiene protocols
      `,
    },
  ],

  faqs: [
    {
      q: "Is getting a dental filling painful?",
      a: "No. The dental filling procedure is usually painless.",
    },
    {
      q: "How long does a filling take?",
      a: "Most fillings take 20–40 minutes, depending on the size and location of the cavity.",
    },
    {
      q: "Are tooth-colored fillings strong?",
      a: "Yes. Modern tooth-colored fillings are strong, durable, and suitable for most teeth.",
    },
    {
      q: "Can fillings fall out?",
      a: "If a filling becomes loose or worn out, it may need replacement. Regular dental checkups help prevent this.",
    },
  ],

  cta: {
    heading: "Book Dental Fillings in Guwahati",
    description: `
If you are experiencing tooth pain or suspect a cavity, don’t delay treatment. Early care can save your tooth.

For pricing details, please call us or walk in for a dental consultation.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 to book your appointment

🦷 Your smile deserves expert care!
  `,
    buttonText: "Book Appointment Now",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
